// extracted by mini-css-extract-plugin
export default {"noClient":"styles_noClient__x+hEo","noClientsText":"styles_noClientsText__RGcpH"};